import React, {Fragment, useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";

import ListTable from "../../../../Common/ListTable";
import FormHeader from "../../../../Common/FormHeader";
import requestApi from "../../../../services/requestApi.service";
import { confirmBoxWithImage, customLoader, showToast } from "../../../../Common/Appcommon";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faTrash } from "@fortawesome/free-solid-svg-icons";

const SenderVerification = () => {
    const form = useForm();
    const { handleSubmit, control, formState: { errors }, setError } = form;

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [fromAddress, setFromAddress] = useState("");
    const [fromName, setFromName] = useState("");
    const [field, setField] = useState();
    const [formData, setFormData] = useState([]);
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        (async () => {
            await loadFormData();
        })();        
    }, []);

    const toggleMadal = async (name) => {
        if(name === "refresh"){
            await loadFormData();
        }else{
            setIsOpenModal(!isOpenModal)
        }
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if(name === "fromname"){
            setFromName(value);
        }else if(name === "emailid"){
            setFromAddress(value);
        }
    }

    const loadFormData = async () => {
        let params = {
            "ENTITY":"SenderAddress", 
            "OPERATION":"GETALL",
            "isWhatsapp" : true
        };
        setShowLoader(true);
        let response = await requestApi.processServerRequest(params);
        setShowLoader(false);
        if(response.issuccess){
            let data = response.data;
            if(data.length > 0){
                setFormData(data[0]);
                setField(data[1] ? data[1] : []);
                setFromAddress(data[0][0] && data[0][0]['fromaddress'] ? data[0][0]['fromaddress'] : "");
            }
        }
    }

    const submitForm = async () => {
        let isValidEmail = checkIsValidEmail();
        if(!isValidEmail) return;
        // avoid to double click
        toggleMadal();
        let params = {
            "ENTITY":"SenderAddress", 
            "OPERATION":"SAVE",
            "fromaddress" : fromAddress,
            "fromname" : fromName,
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            await loadFormData();
        }else{
            showToast("something went wrong...", "", "error");
        }
    }

    const resendEmailVerification = async () => {
        if(formData['status'] === "Verified") {
            showToast("Your Email is already verified", "", "error")
            return
        };
        let params = {
            "ENTITY" : "SenderAddress",
            "OPERATION" : "RESEND",
            "fromaddress" : fromAddress,
        }
        setShowLoader(true);
        let response = await requestApi.processServerRequest(params);
        setShowLoader(false);
        if(!response.issuccess){
            showToast("something went wrong...", "", "error");
        }
    }

    const deleteVerifiedEmail = async () => {
        let confirm = await confirmBoxWithImage("Sure you want delete...","Press Ok to Delete a Sender Address");
        if(!confirm){
            return;
        }
        let params = {
            "ENTITY" : "SenderAddress",
            "OPERATION" : "DELETE",
            "fromaddress" : fromAddress,
        }
        setShowLoader(true);
        let response = await requestApi.processServerRequest(params);
        setShowLoader(false);
        if(response.issuccess){
            await loadFormData();
        }else{
            showToast("something went wrong...", "", "error");
        }
    }

    const checkIsValidEmail = () => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!fromAddress) {
            setError("emailid", {
                type: "manual",
                message: "Please fill the Email Address"
            });
            return false;
        }
        if (!emailPattern.test(fromAddress)) {
            setError("emailid", {
                type: "manual",
                message: "Invalid email format"
            });
            return false;
        }
        return true;
    }

    const getModalContainer = () => {

        return(
            <Modal isOpen={isOpenModal} size={'md'} toggle={toggleMadal}>
                <Form onSubmit={handleSubmit(submitForm)}>
                    <ModalHeader toggle={toggleMadal}>
                        Sender Address Configuration
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label className={'automation-lbl d-flex-alone form-label'} htmlFor="fromname">From Name</Label>
                                <Controller
                                    name="fromname"
                                    control={control}
                                    render={({ field }) => {
                                        return(
                                            <Input
                                                name="fromname"
                                                type="text"
                                                value={fromName}
                                                onChange={e => {
                                                    handleChange(e);
                                                    field.onChange(e);
                                                }}
                                                className={errors.fromname ? 'is-invalid' : ''}
                                                autoComplete={false}
                                            />
                                        )
                                    }}
                                />
                                {errors.fromname && <em className={`error invalid-feedback`}>{errors.fromname.message}</em>}  
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className={'automation-lbl d-flex-alone form-label'} htmlFor="emailid">From Address</Label>
                                <Controller
                                    name="emailid"
                                    control={control}
                                    render={({ field }) => {
                                        return(
                                            <Input
                                                name="emailid"
                                                type="text"
                                                value={fromAddress}
                                                onChange={e => {
                                                    handleChange(e);
                                                    field.onChange(e);
                                                }}
                                                className={errors.emailid ? 'is-invalid' : ''}
                                                autoComplete={false}
                                            />
                                        )
                                    }}
                                />
                                {errors.emailid && <em className={`error invalid-feedback`}>{errors.emailid.message}</em>}      
                            </Col>
                        </Row>               
                    </ModalBody>
                    <ModalFooter>
                        <Button className={`le-button lePrimaryBtn br-4`} type={"submit"}>Save</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        )
    }



    const renderElements = (name, formData) => {
        if(name === "status"){
            let status = formData['status'];
            let customClass = "failed";
            if(status === "Verification Pending"){
                customClass = "pending";
            }else if(status === "Verified"){
                customClass = "success";
            }
            return(
                <>
                    <div className={"w-2 " + customClass}>{status}</div>
                </>
            )
        }else if(name === "resend"){
            return(
                <>
                    <div className={formData['status'] === "Verified" ? "btn-disabled" : "cursor-pointer"} onClick={e => {resendEmailVerification(e)}}>
                        <FontAwesomeIcon icon={faRefresh}/>
                    </div>
                </>
            )
        }else if(name === "delete"){
            return(
                <>
                    <div className = "cursor-pointer" onClick={e => {deleteVerifiedEmail(e)}}>
                        <FontAwesomeIcon icon={faTrash}/>
                    </div>
                </>
            )
        }
    }

    let headerFieldConfig = {
        "From Name" : {
            "class" : "w-2 text-left",
        },
        "From Address" : {
            "class" : "w-2 text-left",
        },
    };

    let customFieldConfig = {
        "fromname" : {
            "class" : "w-2 text-left template-message",
        },
        "fromaddress" : {
            "class" : "w-2 text-left template-message",
        },
        "status" : {
            "render" : "status"
        },
        "resend" : {
            "class": "template-message",
            "render" : "resend"
        },
        "delete" : {
            "class": "template-message",
            "render" : "delete"
        }
    };

    const buttonOptions = [
        {
            label : formData.length > 0 ? 'Refresh' : 'New Sender Email',
            name : formData.length > 0 ? 'refresh' : 'new_email',
            icon :formData.length > 0 ? faRefresh :  faCirclePlus,
            className : formData[0] && formData[0]['status'] === "Verified" ? "hide" : "",
        },
    ];

    const getContent = () =>{
        return (
            <Fragment>
                <FormHeader
                    buttonOptions={buttonOptions}
                    handleBtnClick={toggleMadal}
                />
                <ListTable
                    key={Math.random()}
                    formData={formData}
                    fields={field}
                    renderElements={renderElements}
                    headerConfig={headerFieldConfig}
                    config={customFieldConfig}
                    formName={"table_12"}
                    noDataMsg={`Templates not found`}
                    prefix={'templates'}
                    customClass={'no-border-table'}
                />
                {getModalContainer()}
            </Fragment>
        )
    }

    return (
        <>
            {customLoader({
                showLoader: showLoader,
                customClass: "custom-class",
                mainContent: getContent(),
            })}
        </>
    )

}
export default SenderVerification;
